export const getCoinDisplayName = (coinName) => {
    const displayNameMap = {
        SUIBTC: 'wBTC',
        TBTC: 'tBTC',
        STSUI: 'stSUI',
        XAUM: 'XAUm',
        WUSDC: 'wUSDC',
        MUSD: 'mUSD',
        SUIUSDT: 'suiUSDT',
        VSUI: 'vSUI',
        ESUI: 'eSUI',
        AFSUI: 'afSUI',
        EBTC: 'eBTC',
        EGUSDC: 'egUSDC',
        HASUI: 'haSUI',
    };
    return displayNameMap[coinName] || coinName;
};
/**
 * Normalizes the address part of a Sui coin type to 64 hex chars (e.g. 0x2 -> 0x00...02).
 * Use once per coin type so a single comparison works for both padded and non-padded forms.
 */
export function normalizeCoinType(coinType) {
    const i = coinType.indexOf('::');
    if (i === -1)
        return coinType;
    const addr = coinType.slice(0, i);
    const rest = coinType.slice(i);
    if (!addr.startsWith('0x'))
        return coinType;
    const hex = addr.slice(2).toLowerCase();
    const padded = hex.padStart(64, '0');
    return '0x' + padded + rest;
}
// WBTC LayerZero (canonical zero-padded form)
export const wbtc_layer0_coinType = '0x0041f9f9344cac094454cd574e333c4fdb132d7bcc9379bcd4aab485b2a63942::wbtc::WBTC';
// WBTC LayerZero non-padded form
export const wbtc_layer0_coinType_raw = '0x41f9f9344cac094454cd574e333c4fdb132d7bcc9379bcd4aab485b2a63942::wbtc::WBTC';
// WBTC Wormhole (canonical zero-padded form)
export const wbtc_wormhole_coinType = '0x027792d9fed7f9844eb4839566001bb6f6cb4804f66aa2da6fe1ee242d896881::coin::COIN';
// WBTC Wormhole non-padded form
export const wbtc_wormhole_coinType_raw = '0x27792d9fed7f9844eb4839566001bb6f6cb4804f66aa2da6fe1ee242d896881::coin::COIN';
export const alpha_pool_id = '0x06a4922346ae433e9a2fff4db900d760e0cbfdef748f48385f430ef4d042a6f8';
